import React from 'react'
import { Link } from 'react-router-dom'
import { money } from '../financial/formatting'
import { fmtLeadTime } from './model'

// Counted sales. Money is null when a sale has no frozen payout, and is
// shown as a dash rather than $0.00, which would claim we owe nothing.
export default function SoldTable({ leads, timezone, palette }) {
  const cash = (v) => (v === null || v === undefined ? '—' : money(v))
  return (
    <table className="sl-table">
      <thead>
        <tr>
          <th>Lead ID</th>
          <th>Buyer</th>
          <th>Origin</th>
          <th>Time (ET)</th>
          <th className="sl-num">Total</th>
          <th className="sl-num"><Swatch color="var(--share-ours)" />Ours</th>
          <th className="sl-num"><Swatch color="var(--share-partner)" />Partner</th>
        </tr>
      </thead>
      <tbody>
        {leads.map((l) => (
          <tr key={l.lead_id}>
            <td><LeadLink id={l.lead_id} /></td>
            <td>{l.winner ? <BuyerPill label={l.winner} color={palette.forLabel(l.winner)} /> : '—'}</td>
            <td>{l.origin}</td>
            <td style={{ whiteSpace: 'nowrap' }}>{fmtLeadTime(l.created_at, timezone)}</td>
            <td className="sl-num">{cash(l.revenue)}</td>
            <td className="sl-num">{cash(l.our_share)}</td>
            <td className="sl-num">{cash(l.partner_share)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export function LeadLink({ id }) {
  return (
    <Link to={`/lead-inspector/${id}`} style={{ fontFamily: 'ui-monospace, monospace', fontSize: 12, color: 'var(--accent)', textDecoration: 'none' }}>
      #{id}
    </Link>
  )
}

function BuyerPill({ label, color }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '2px 9px', borderRadius: 999, fontSize: 12, fontWeight: 600, border: '1px solid var(--border)', whiteSpace: 'nowrap' }}>
      <span aria-hidden="true" style={{ width: 8, height: 8, borderRadius: 999, background: color }} />
      {label}
    </span>
  )
}

function Swatch({ color }) {
  return <span aria-hidden="true" style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 2, background: color, marginRight: 5 }} />
}
